export default __webpack_public_path__ + "shareableb20cdf.png";